import WidgetWrapper from '../../wrapper/WidgetWrapper';
import dom from '../../wrapper/DomWrapper';
import NumericPagination from './NumericPagination';
import LayoutController from './LayoutController';
import ItemsRenderer from './renderer';
import EndlessScroll from './EndlessScroll';

const parse = (settings) => {
  try {
    return JSON.parse(settings);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }

  return null;
};

const getPagination = (paginationType, options, container, renderer) => {
  switch (paginationType) {
    case 'infinite':
      return new EndlessScroll(options, container, renderer);
    default:
      return new NumericPagination(options, container, renderer);
  }
};

class ItemsView extends WidgetWrapper {
  constructor(selector) {
    super(selector);
    this.elements = dom.getCollection(selector);
  }

  init = () => {
    this.elements.forEach((element) => {
      const { settings: settingsStr, widgetId } = element.dataset;
      const settings = parse(settingsStr);
      if (!settings || !widgetId) return;

      const { paginationType, layoutSettings, itemSize } = settings;
      const options = layoutSettings[layoutSettings.layoutType] || {};
      (new LayoutController(
        element,
        settings,
        new ItemsRenderer(dom.getElement(`#item-template-${widgetId}`)),
        new ItemsRenderer(dom.getElement(`#placeholder-template-${widgetId}`)),
        new ItemsRenderer(dom.getElement(`#spinner-template-${widgetId}`)),
        new ItemsRenderer(dom.getElement(`#retry-template-${widgetId}`)),
        getPagination(
          paginationType,
          { ...options, itemSize, selector: `.items-view-pagination-${widgetId}` },
          element,
          new ItemsRenderer(dom.getElement(`#pagination-template-${widgetId}`)),
        ),
      )).init();
    });
  };
}

export default ItemsView;
